<nav class="project-nav" aria-label="Project sections">
  <div class="project-nav__inner">
    <a class="project-nav__identity" [routerLink]="['/projects', projectSlug]">
      @if (projectDetailsService.selectedProject?.project?.profileUrl) {
      <img [src]="projectDetailsService.selectedProject?.project?.profileUrl" width="130" height="44"
        [alt]="projectDetailsService.selectedProject?.project?.projectName" loading="lazy">
      }
      <span>{{ projectDetailsService.selectedProject?.project?.projectName }}</span>
    </a>

    <div class="project-nav__links">
      <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        [routerLink]="['/projects', projectSlug]">Overview</a>
      <a routerLinkActive="active"
        [routerLink]="['/projects', projectSlug, 'amenities-details']">Amenities</a>
      <a routerLinkActive="active"
        [routerLink]="['/projects', projectSlug, 'paymentplan-details']">Payment Plan</a>
      <a routerLinkActive="active"
        [routerLink]="['/projects', projectSlug, 'floorplan-details']">Floor Plans</a>
      <a routerLinkActive="active"
        [routerLink]="['/projects', projectSlug, 'locations-details']">Location</a>
      <a routerLinkActive="active"
        [routerLink]="['/projects', projectSlug, 'masterplan-details']">Master Plan</a>
      <a routerLinkActive="active"
        [routerLink]="['/projects', projectSlug, 'gallery-details']">Gallery</a>
    </div>
  </div>
</nav>
